import { Injectable } from '@angular/core';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { AssetOnCompletionModel } from '../components/messages/model/data-message.model';

@Injectable({ providedIn: 'root' })
export class NexsysAssetsOnCompletionService extends EditableGridService {
	private readonly BASE_URL = '/products';
	private reloadListEvent = new BehaviorSubject({});
	private reloadListListener = this.reloadListEvent.asObservable();

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * GET - Return the list of Assets
	 */
	getAssets(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/product-assets`);
	}

	/**
	 * POST - Create a new asset config entry.
	 */
	createAssetConfig(assetConfig: AssetOnCompletionModel): Observable<any> {
		return this.httpClient.post(
			`${this.systemApiService.api.orders}${this.BASE_URL}/product-assets`, assetConfig);
	}

	/**
	 * PUT - Saves an existing asset config entry.
	 */
	updateAssetConfig(assetConfig: AssetOnCompletionModel): Observable<any> {
		return this.httpClient.put(
			`${this.systemApiService.api.orders}${this.BASE_URL}/product-assets/${assetConfig.id}`,
			assetConfig);
	}

	/**
	 * GET - Return the list of Assets by Origin id
	 */
	getDocumentTypesByOrigin(originId: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/product-assets/doc-types/${originId}`);
	}

	/**
	 * DELETE - Deletes an asset by it's id
	 */
	deleteAsset(id: string): Observable<any> {
		return this.httpClient.delete(`${this.systemApiService.api.orders}${this.BASE_URL}/product-assets/${id}`);
	}

	/**
	 * Sets component data communication.
	 * @param data
	 */
	setReloadListEvent(data: any): void {
		this.reloadListEvent.next(data);
	}

	/**
	 * Returns si the list should be reloaded.
	 */
	getReloadListEventListener(): Observable<any> {
		return this.reloadListListener;
	}
}
